export function Logger(debugEnabled) {

  return {
    debug: (message, ...attributes) => {
      if (debugEnabled) console.debug(message, attributes);
    },
    info: (message, ...attributes) => {
      console.log(message, attributes);
    },
    warn: (message, ...attributes) => {
      console.warn(message, attributes);
    },
    error: (message, ...attributes) => {
      console.error(message, attributes);
    }
  }
}
